RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TitleBar = RivalIQ.apps.Dashboard.views.TitleBar.extend({
        serializeData: function () {
            const me = this;

            const data = RivalIQ.apps.Dashboard.views.TitleBar.prototype.serializeData.apply(me, arguments);

            return _.extend(data, {
                title: me.dashboardModel.getExportTitle(),
                companySetName: null,
                exportShowFocusCompany: false,
                exportShowLandscapeName: false
            });
        }
    });

    views.TitlePage = views.TitleBar.extend({
        className: 'export-cover-page',
        template: '#pdfCoverPageTemplate'
    });
});
